import { render } from "./ViewBanner.vue?vue&type=template&id=5d3cf87c&scoped=true"
import script from "./ViewBanner.vue?vue&type=script&lang=js"
export * from "./ViewBanner.vue?vue&type=script&lang=js"

import "./ViewBanner.vue?vue&type=style&index=0&id=5d3cf87c&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3cf87c"]])

export default __exports__